import React from "react";
import { FadeUp } from "../motion/Reveal";

const CHAPTERS = [
    {
        num: "01",
        title: "Visão",
        body: "Tecnologia sem propósito é ruído. Cada linha de código que escrevemos existe para mover um número real do seu negócio — receita, retenção, tempo, ou reputação.",
    },
    {
        num: "02",
        title: "Método",
        body: "Descoberta obsessiva, entregas em ciclos curtos e um único ponto de contato. Você acompanha o produto crescendo por dentro do nosso board — sem PMs entre você e o time.",
    },
    {
        num: "03",
        title: "Ofício",
        body: "Design como estratégia, engenharia como craft. Trabalhamos com stacks modernos (React, Node, Python, FastAPI, IA) e recusamos entregar qualquer coisa que não usaríamos nós mesmos.",
    },
    {
        num: "04",
        title: "Parceria",
        body: "Não somos fábrica. Você contrata um squad enxuto que pensa junto no problema, questiona o brief, e assume o resultado — do primeiro sketch ao deploy em produção.",
    },
];

export default function Manifesto() {
    return (
        <section
            id="manifesto"
            className="relative py-32 md:py-40 border-b border-white/10"
            data-testid="manifesto-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10">
                <FadeUp>
                    <div className="flex items-center gap-3 mb-16">
                        <span className="font-mono-tech text-xs tracking-widest text-[#00FF66] uppercase">
                            (Manifesto)
                        </span>
                        <span className="w-16 h-[1px] bg-white/20" />
                        <span className="font-mono-tech text-xs tracking-widest text-white/40 uppercase">
                            04 Capítulos
                        </span>
                    </div>
                </FadeUp>

                <FadeUp delay={0.1}>
                    <h2 className="font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter text-white max-w-5xl mb-24">
                        Não vendemos horas.
                        <br />
                        <span className="text-white/40">
                            Vendemos produtos que
                        </span>
                        <br />
                        <span className="text-[#00FF66]">
                            movem a agulha.
                        </span>
                    </h2>
                </FadeUp>

                <div className="space-y-24 md:space-y-32">
                    {CHAPTERS.map((ch, i) => (
                        <FadeUp key={ch.num} delay={i * 0.05}>
                            <div className="grid grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 pt-10">
                                <div className="col-span-12 md:col-span-4 flex items-baseline gap-6">
                                    <span className="font-display text-[18vw] md:text-[9vw] leading-none text-white/[0.06]">
                                        {ch.num}
                                    </span>
                                    <span className="font-display uppercase text-3xl md:text-4xl text-white tracking-tight">
                                        {ch.title}
                                    </span>
                                </div>
                                <div className="col-span-12 md:col-span-7 md:col-start-6">
                                    <p className="text-white/70 text-xl md:text-2xl leading-relaxed max-w-2xl">
                                        {ch.body}
                                    </p>
                                </div>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
